import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import useAuth from '../hooks/useAuth';
import usePolling from '../hooks/usePolling';
import StatusBadge from '../components/StatusBadge';

function iniciais(nome) {
  if (!nome) return '?';
  const parts = nome.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

const ATENDENTES = [
  { id: 1, nome: 'Ana Lima', email: 'ana@coti.com', perfil: 'Recepcionista', online: true, conv: 4 },
  { id: 2, nome: 'Bruna Souza', email: 'bruna@coti.com', perfil: 'Recepcionista', online: false, conv: 7 },
];

const MEDICOS = [
  { id: 1, nome: 'Dr. Paulo Mendes', especialidade: 'Ortopedia — Joelho', crm: 'CRM 12345', ia_ativa: true, conv_sem: 14 },
  { id: 2, nome: 'Dra. Carla Neves', especialidade: 'Ortopedia — Ombro', crm: 'CRM 67890', ia_ativa: false, conv_sem: 9 },
];

const ABAS = [
  { key: 'visao-geral', label: 'Visão geral' },
  { key: 'equipe', label: 'Equipe' },
  { key: 'medicos', label: 'Médicos' },
];

export default function PainelGerente() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const [aba, setAba] = useState('visao-geral');
  const [dashboard, setDashboard] = useState(null);
  const [conversas, setConversas] = useState([]);

  const fetchDados = useCallback(async () => {
    if (aba !== 'visao-geral') return;
    try {
      const { data: dash } = await api.get('/dashboard');
      setDashboard(dash.data?.metricas_dia);
      setConversas(dash.data?.conversas ?? []);
    } catch {}
  }, [aba]);

  usePolling(fetchDados, 5000);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const metricas = [
    { label: 'Atendimentos hoje', value: dashboard?.total_atendimentos ?? '—', color: '#1A1A2E', detalhe: null },
    { label: 'Resolvidos pela IA', value: dashboard?.resolvidos_ia ?? '—', color: '#1A1A2E', detalhe: dashboard?.percentual_ia != null ? `${dashboard.percentual_ia}% do total` : null },
    { label: 'Agendamentos', value: dashboard?.agendamentos ?? '—', color: '#1A1A2E', detalhe: null },
    { label: 'Urgências', value: dashboard?.urgencias ?? '—', color: '#991B1B', detalhe: null },
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F9FA', fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Topbar */}
      <div style={{
        backgroundColor: '#FFFFFF',
        borderBottom: '0.5px solid #E9ECEF',
        padding: '0 16px',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '56px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              backgroundColor: '#E6F1FB',
              color: '#185FA5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '13px',
              fontWeight: 600,
            }}>
              {iniciais(usuario?.nome)}
            </div>
            <div>
              <p style={{ margin: 0, fontSize: '13px', fontWeight: 500, color: '#1A1A2E' }}>{usuario?.nome}</p>
              <p style={{ margin: 0, fontSize: '11px', color: '#6C757D' }}>Gerente · Acesso total</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            style={{
              padding: '4px 10px',
              backgroundColor: '#F1F3F5',
              color: '#6C757D',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12px',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Sair
          </button>
        </div>

        <div style={{ display: 'flex', gap: '4px' }}>
          {ABAS.map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setAba(key)}
              style={{
                background: 'none',
                border: 'none',
                borderBottom: aba === key ? '2px solid #185FA5' : '2px solid transparent',
                color: aba === key ? '#185FA5' : '#6C757D',
                fontSize: '13px',
                fontWeight: aba === key ? 500 : 400,
                padding: '8px 14px',
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding: '16px' }}>

        {/* Aba: Visão geral */}
        {aba === 'visao-geral' && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '16px' }}>
              {metricas.map(({ label, value, color, detalhe }) => (
                <div key={label} style={{
                  backgroundColor: '#FFFFFF',
                  borderRadius: '8px',
                  padding: '12px 14px',
                  border: '0.5px solid #E9ECEF',
                }}>
                  <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#6C757D' }}>{label}</p>
                  <p style={{ margin: 0, fontSize: '22px', fontWeight: 500, color }}>{value}</p>
                  {detalhe && (
                    <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#ADB5BD' }}>{detalhe}</p>
                  )}
                </div>
              ))}
            </div>

            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              border: '0.5px solid #E9ECEF',
              overflow: 'hidden',
            }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                <thead>
                  <tr style={{ borderBottom: '0.5px solid #E9ECEF' }}>
                    {['Paciente', 'Médico', 'Atendente', 'Status', 'Hora'].map(col => (
                      <th key={col} style={{
                        padding: '8px 12px',
                        textAlign: 'left',
                        fontWeight: 500,
                        color: '#6C757D',
                      }}>
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {conversas.length === 0 ? (
                    <tr>
                      <td colSpan={5} style={{ padding: '24px', textAlign: 'center', color: '#ADB5BD' }}>
                        Nenhum dado disponível
                      </td>
                    </tr>
                  ) : (
                    conversas.map(c => (
                      <tr
                        key={c.id}
                        style={{ borderBottom: '0.5px solid #E9ECEF', cursor: 'pointer' }}
                        onClick={() => navigate(`/conversa/${c.id}`)}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F8F9FA'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <td style={{ padding: '7px 12px', color: '#1A1A2E' }}>{c.paciente_nome}</td>
                        <td style={{ padding: '7px 12px', color: '#1A1A2E' }}>{c.medico_nome ?? '—'}</td>
                        <td style={{ padding: '7px 12px', color: '#1A1A2E' }}>{c.atendente_nome ?? '—'}</td>
                        <td style={{ padding: '7px 12px' }}><StatusBadge status={c.status} /></td>
                        <td style={{ padding: '7px 12px', color: '#6C757D' }}>
                          {c.atualizado_em
                            ? new Date(c.atualizado_em).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
                            : '—'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}

        {/* Aba: Equipe */}
        {aba === 'equipe' && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <p style={{ margin: 0, fontSize: '13px', fontWeight: 500, color: '#1A1A2E' }}>
                Atendentes cadastradas
              </p>
              <button style={{
                padding: '5px 12px',
                backgroundColor: '#185FA5',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '8px',
                fontSize: '12px',
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}>
                + Nova atendente
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {ATENDENTES.map(a => (
                <div key={a.id} style={{
                  backgroundColor: '#FFFFFF',
                  border: '0.5px solid #E9ECEF',
                  borderRadius: '12px',
                  padding: '12px 14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                }}>
                  <div style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    backgroundColor: '#E6F1FB',
                    color: '#185FA5',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '13px',
                    fontWeight: 600,
                    flexShrink: 0,
                  }}>
                    {iniciais(a.nome)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ margin: 0, fontSize: '13px', fontWeight: 500, color: '#1A1A2E' }}>{a.nome}</p>
                    <p style={{ margin: '1px 0 0', fontSize: '11px', color: '#6C757D' }}>
                      {a.email} · {a.perfil}
                    </p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{
                      fontSize: '11px',
                      fontWeight: 500,
                      padding: '2px 8px',
                      borderRadius: '99px',
                      backgroundColor: a.online ? '#E1F5EE' : '#F1F3F5',
                      color: a.online ? '#0F6E56' : '#6C757D',
                    }}>
                      {a.online ? 'Online' : 'Offline'}
                    </span>
                    <span style={{ fontSize: '11px', color: '#ADB5BD' }}>{a.conv} conv. hoje</span>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px' }}>✏️</button>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px' }}>🔒</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Aba: Médicos */}
        {aba === 'medicos' && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <p style={{ margin: 0, fontSize: '13px', fontWeight: 500, color: '#1A1A2E' }}>
                Profissionais e agentes de IA
              </p>
              <button style={{
                padding: '5px 12px',
                backgroundColor: '#185FA5',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '8px',
                fontSize: '12px',
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}>
                + Novo médico
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {MEDICOS.map(m => (
                <div key={m.id} style={{
                  backgroundColor: '#FFFFFF',
                  border: '0.5px solid #E9ECEF',
                  borderRadius: '12px',
                  padding: '12px 14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                }}>
                  <div style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    backgroundColor: '#E1F5EE',
                    color: '#0F6E56',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '13px',
                    fontWeight: 600,
                    flexShrink: 0,
                  }}>
                    {iniciais(m.nome)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ margin: 0, fontSize: '13px', fontWeight: 500, color: '#1A1A2E' }}>{m.nome}</p>
                    <p style={{ margin: '1px 0 0', fontSize: '11px', color: '#6C757D' }}>
                      {m.especialidade} · {m.crm}
                    </p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{
                      fontSize: '11px',
                      fontWeight: 500,
                      padding: '2px 8px',
                      borderRadius: '99px',
                      backgroundColor: m.ia_ativa ? '#E1F5EE' : '#FAEEDA',
                      color: m.ia_ativa ? '#0F6E56' : '#854F0B',
                    }}>
                      {m.ia_ativa ? 'IA ativa' : 'Pausada'}
                    </span>
                    <span style={{ fontSize: '11px', color: '#ADB5BD' }}>{m.conv_sem} conv./sem</span>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px' }}>⚙️</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
